import { render, staticRenderFns } from "./SavePageAsPdf.vue?vue&type=template&id=01a9bdae&scoped=true&"
import script from "./SavePageAsPdf.vue?vue&type=script&lang=js&"
export * from "./SavePageAsPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a9bdae",
  null
  
)

export default component.exports